// The title page's hero (the brief, "Hero"): the cover, the game's title art (kept on typographic covers too: the
// cover has no type, only cards drop the title), the by-line, one line of facts and the one primary action.

import { INPUT_LABEL, label, type Game } from "../../catalogue.ts";
import { coverStyle, creatorName, titleArt } from "../../components.ts";
import { h, link } from "../../dom.ts";
import { coverUrl } from "../../rows.ts";
import { titleActions } from "./actions.ts";

const SESSION: Record<string, string> = { short: "Quick sessions", medium: "Medium sessions", long: "Long sessions" };

/** "Racing · Quick sessions · Multiplayer · Keyboard, Gamepad": what you'd ask before pressing Play. */
export function factLine(g: Pick<Game, "genre" | "session" | "facets">): string {
  const input = (g.facets?.input ?? []).map((i) => INPUT_LABEL[i] ?? label(i));
  return [label(g.genre), g.session ? SESSION[g.session] : null, g.facets?.multiplayer ? "Multiplayer" : null, input.length ? input.join(", ") : null].filter(Boolean).join(" · ");
}

export function titleHero(g: Game, kicker: (HTMLElement | null)[], version: HTMLElement | null): HTMLElement {
  const art = coverUrl(g, "full");
  return h(
    "header",
    { class: "gt-hero" },
    h("div", { class: "gt-art", role: art ? "img" : null, "aria-label": art ? `${g.title} cover` : null, style: coverStyle(g, "full") }),
    h(
      "div",
      { class: "gt-hero-text" },
      h("div", { class: "gt-kicker" }, kicker),
      // one h1 always: the title art inside it (its alt is the title), or the title as text when there's no logo
      h("h1", { class: "gt-title" }, titleArt(g, "gt-title-art", () => h("span", null, g.title))),
      h("p", { class: "gt-by" }, "by ", link(`/c/${g.creator.id}`, null, creatorName(g.creator.name))),
      h("p", { class: "gt-facts" }, factLine(g)),
      version,
      titleActions(g),
    ),
  );
}
